export default {
  cm: 'centimeters',
  ft: 'feet',
  in: 'inches',
  m: 'meters',
  mm: 'millimeters',
  pcs: 'pieces',
  yd: 'yards',
  // area
  ft2: 'square feet',
  in2: 'square inch',
  sq2: 'square meters',
  yd2: 'square yards',
};
